import React from "react";
import CustomButton from '../components/CustomButton';
import { useNavigate } from 'react-router-dom';

export default function Thankyou() {

    const navigate = useNavigate();

    const home = () => {
        navigate('/')
    }

    return (
        <div className='story flex-col justify-center' style={{ backgroundImage: "url(/main-bg.png)"}}>
            <div>
                <img width="100%" alt="Thank you!" src="/thankyou.png" />
            </div>
            
            <div className="text-center font-bold py-6 ">
                <CustomButton text="Play Again" onClick={home}/>
            </div>
        </div>
    )
}